<template>
  <div class="magnus-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_magnus ∝ v_flow × ω_spin$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Airflow Lines -->
          <g v-for="i in 11" :key="'l'+i" stroke="rgba(0, 210, 255, 0.1)" stroke-width="1">
             <path :d="calcAirflow(i)" fill="none" />
          </g>

          <!-- Spinning Ball -->
          <g :transform="`translate(200, ${120 + offset})`">
             <circle r="25" fill="#ff4757" stroke="#fff" stroke-width="2" />
             <!-- Rotation lines -->
             <line x1="-20" y1="0" x2="20" y2="0" stroke="#fff" stroke-width="2">
                <animateTransform attributeName="transform" type="rotate" from="0" to="360" :dur="`${2/(spin+0.1)}s`" repeatCount="indefinite" />
             </line>
             <circle r="28" fill="none" stroke="#fff" stroke-dasharray="2,5" opacity="0.4" />
          </g>

          <!-- Pressure labels -->
          <text x="180" :y="80 + offset" fill="#2ed573" font-size="8">低压区 (流速快)</text>
          <text x="180" :y="180 + offset" fill="#ff4757" font-size="8">高压区 (流速慢)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>侧向力 F_mag: {{ (spin * speed * 0.1).toFixed(1) }} N</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>自旋角速度 ω</label>
             <el-slider v-model="spin" :min="-10" :max="10" size="mini"></el-slider>
          </div>
          <div class="row items-center">
             <label>前进风速 v</label>
             <el-slider v-model="speed" :min="1" :max="20" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当一个旋转的球体在流体（如空气）中移动时，其表面会带动周围流体共同旋转。球体一侧的自旋方向与气流相同，使得该侧流速加快、压强减小；另一侧则相反。根据伯努利定律，两边的压强差会产生一个垂直于速度方向的横向力，使球体路径弯曲。这就是足球中的“香蕉球”或乒乓球中弧圈球的物理秘密。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MagnusEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      spin: 5,
      speed: 10
    }
  },
  computed: {
    offset() { return -this.spin * this.speed * 0.5; },
    calcAirflow() {
       return (i) => {
          let y = i * 20 + 20;
          let bend = (this.spin * this.speed * 0.1) * Math.sin((y-120)/60); // eslint-disable-line no-unused-vars
          return `M 0,${y} Q 200,${y + this.offset} 400,${y}`;
       };
    }
  }
}
</script>

<style scoped lang="scss">
.magnus-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
